import { PromotionsStylesSchema } from './Promotions.styles';

export const promotionsStyles: PromotionsStylesSchema = {
  heading: {
    mb: '2',
    color: 'white',
    fontWeight: '700',
  },
  promotionWrapper: {
    p: '4',
    bg: 'white',
    my: '3',
    boxShadow: 'lg',
    borderRadius: 'md',
    border: '2px solid',
    borderColor: 'epsilon.500',
  },
  flexWrapper: { gap: '4', pt: '4', justifyContent: 'space-between' },
  termsAndConditions: {
    color: 'gray.700',
    fontSize: 'sm',
    pt: '1',
  },
};
